export const DefaultMenuResources = {
	es: {
		['select_an_office']: 'Seleccione una oficina',

	},
	en: {
		['select_an_office']: 'Select an office',
	}
}
